import React from 'react';
import styled from 'styled-components';
import Footer from '../Footer';
import PartnersHero from './components/PartnersHero';
import WhyBecomeAPartner from './components/WhyBecomeAPartner';
import EntryRequirements from './components/EntryRequirements';
import PartnerAndRevenueCosts from './components/PartnerAndRevenueCosts';
import NextSteps from './components/NextSteps';

const LandingContainer = styled.div`
  img {
    max-width: 100%;
  }
`;

const Partners = () => (
  <LandingContainer>
    <PartnersHero />
    <WhyBecomeAPartner />
    <EntryRequirements />
    <PartnerAndRevenueCosts />
    <NextSteps />
  </LandingContainer>
);

export default Partners;
